import { render, staticRenderFns } from "./LinkRewardMessage.vue?vue&type=template&id=2942c1d2"
import script from "./LinkRewardMessage.vue?vue&type=script&lang=js"
export * from "./LinkRewardMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports